import { Box, Stack } from '@mui/material';
import BetArea from '../../../../../../../components/common/betArea';

import { useEffect, useState } from 'react';
import BaseImage from '../../../../../../../components/common/baseImage';
import { RouletteBetAreaType1 } from '../constants';

export const BetAreaContainer = () => {
    const [betAreaElements, setBetAreaElements] = useState<Array<JSX.Element>>(
        []
    );
    useEffect(() => {
        const bae = new Array<JSX.Element>();
        for (const betAreaType of RouletteBetAreaType1) {
            const ele = (
                <Box
                    sx={betAreaType.boxStyle}
                    key={`bet-1-${betAreaType.betType}`}
                >
                    <BetArea
                        style={betAreaType.style}
                        betType={betAreaType.betType}
                        confirmedChipScale={0.4}
                        pendingChipScale={0.3}
                        isEnableConfirmPanel={false}
                    />
                </Box>
            );
            bae.push(ele);
        }
        setBetAreaElements(bae);
    }, []);
    return (
        <Stack sx={{ width: '340px', height: '688px', position: 'relative' }}>
            <BaseImage
                className="roul_betarea roul_vert_betarea1_png"
                isMultiLang={true}
                scale={0.46}
            />
            {betAreaElements}
        </Stack>
    );
};
